// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.path_dAJpi{
    display: flex;
    align-items: center;
    gap: 5px;
    color: #1A1A1A;
    cursor: pointer;
    p{
        color: #737373;
        margin: 0;
    }
}
.title_Sztfk{
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 500;
}
.description_FuIwp{
    color: #1A1A1A;
    font-weight: 400;
}

.additionalContent_fsKLC{
    display: flex;
    flex-direction: column;
    border: 1px solid #e6e6e6;
    padding: 20px;
    border-radius: 12px;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    -ms-border-radius: 12px;
    -o-border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/HelpPage/TemplateArticleHelp/TemplateArticleHelp.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf;QACI,cAAc;QACd,SAAS;IACb;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".path{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    color: #1A1A1A;\n    cursor: pointer;\n    p{\n        color: #737373;\n        margin: 0;\n    }\n}\n.title{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-weight: 500;\n}\n.description{\n    color: #1A1A1A;\n    font-weight: 400;\n}\n\n.additionalContent{\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #e6e6e6;\n    padding: 20px;\n    border-radius: 12px;\n    -webkit-border-radius: 12px;\n    -moz-border-radius: 12px;\n    -ms-border-radius: 12px;\n    -o-border-radius: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"path": `path_dAJpi`,
	"title": `title_Sztfk`,
	"description": `description_FuIwp`,
	"additionalContent": `additionalContent_fsKLC`
};
export default ___CSS_LOADER_EXPORT___;
